import gql from 'graphql-tag';

export const thumbnailInfoFragment = gql`
  fragment thumbnailInfoFragment on ThumbnailInfo {
    dokkioClass
    contentType
    bytes
  }
`;

export default thumbnailInfoFragment;
